import { render, staticRenderFns } from "./CommonFaq.vue?vue&type=template&id=35caa166&scoped=true&"
import script from "./CommonFaq.vue?vue&type=script&lang=ts&"
export * from "./CommonFaq.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFaq.vue?vue&type=style&index=0&id=35caa166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35caa166",
  null
  
)

export default component.exports